// extracted by mini-css-extract-plugin
module.exports = {"label":"_1cW9PVCmKAeGfsuCb9v3v3","content":"_29hIXG96w_MUhjyOhaAhVp"};